
import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { EditDataConnectClusterDialogBody, EditDataConnectClusterDialogProps, EditDataConnectClusterDialogState } from '~src/settings/dataconnect-settings/sections/dataConnectMultiCluster/EditDataConnectClusterDialog';
import { IUpdateBaasClusterNameParams, IUpdateBaasClusterNameResult } from '~src/settings/dataconnect-settings/serverApi/requests/UpdateBaasClusterNameRequest';
import { BaasEdgePoolAndCluster } from '~src/settings/dataconnect-settings/serverApi/resources/BaasEdgePoolAndCluster';

import { ActionItemInfo } from '../MoreActionsMenu';
import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';

export function openEditClusterDialog(actionItem: ActionItemInfo, refreshEdgePools: () => void) {
  const action = (_: EditDataConnectClusterDialogProps, state: EditDataConnectClusterDialogState) => {
    const updateProps: IUpdateBaasClusterNameParams = {
      clusterId: actionItem.clusterId,
      displayName: state.clusterName,
      siteId: actionItem.siteId,
    };

    return BaasEdgePoolAndCluster.updateBaasClusterName(updateProps)
      .then((result: IUpdateBaasClusterNameResult) => {
        refreshEdgePools();
        if(result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsEditClusterSuccess() });
        }
        if(result.errors) {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
          });
        }
        return Promise.resolve({});
      });
  };

  const dialogInstance = openReactActionDialog({
    title: Messages.dataConnectSiteSettingsEditPool(),
    bodyComponent: EditDataConnectClusterDialogBody,
    initialBodyProps: { existingClusterNames: actionItem.existingClusterNames },
    initialDialogState: { clusterName: actionItem.clusterName, hasError: false },
    actionName: Messages.save(),
    action: action,
    actionDisabled: (_, state: EditDataConnectClusterDialogState) => state.clusterName.length === 0 || state.hasError,
    dismissDialogOnActionFailed: true,
    dialogWidth: TabDialogWidth.width375px,
  });

  return Promise.resolve(dialogInstance.result);
}
